module.exports = __webpack_public_path__ + "img/Albanija.73e63c70.png";